import { lazy, type LazyExoticComponent } from 'react';

import type {
	ActionRendererFor,
	ReadOnlyActionRendererFor,
} from '@atlassian/conversation-assistant-message-actions-api/types';

export const PlanCompleteRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<'plan_complete'>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/plan-complete-renderer" */ './PlanCompleteRenderer'
	).then((m) => ({ default: m.PlanCompleteRenderer })),
);

export const PlanCompleteReadOnlyRendererAsync: LazyExoticComponent<
	(props: ReadOnlyActionRendererFor<'plan_complete'>) => React.JSX.Element | null
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/plan-complete-readonly-renderer" */ './PlanCompleteRenderer'
	).then((m) => ({ default: m.PlanCompleteReadOnlyRenderer })),
);
